<script>
    import I18n from '@js/modules/translations';

    import {fetchSearchRecommendation} from '@js/actions/searchActions';

    import RidesRecents from '@js/components/ride/list/RidesRecents.svelte';
    import RideCard from '@js/components/ride/RideCard.svelte';

    let recommendedRides = $state();

    fetchSearchRecommendation('ride', 8, true)
        .then((response) => {
            recommendedRides = response?.rides;
        });
</script>

<RidesRecents class="mt-12"
              separator={true}/>

{#if recommendedRides}
    <div class="mt-12 mx-4">
        <h2 class="text-3xl mb-1">
            {I18n.t('js.views.popular.title')}
        </h2>

        <div class="row">
            {#each recommendedRides as recommendedRide (recommendedRide.id)}
                <div class="col s12 m6 l4">
                    <RideCard ride={recommendedRide}/>
                </div>
            {/each}
        </div>
    </div>
{/if}
